module.exports = __webpack_public_path__ + "img/pipeline.a5ceb5f5.png";